
import { useToasts } from "react-toast-notifications";
import {
    CUSTOM_WARNING_MESSAGES,
    DEFAULT_ERROR
} from "../utils/config";
import { _no } from "../utils";

export const useToastNotification = () => {

    const defaultSetup = {
        autoDismiss: true
    };

    const { addToast } = useToasts();
    const generateLinkContent = (link, message) => {
        return <a
            href={link}
            target="_blank"
            rel="noreferrer"
            style={{
                color: "inherit",
                textDecoration: "none"
            }}
        >
            {message}
        </a>;
    };

    const showToast = (isSuccess, content) => {
        if (isSuccess) {
            success(
                content
            );
            return;
        }

        error(
            content
        );
    };

    const showTransactionErrorToast = (content) => {
        let warningMessage;
        let isWarning = false;

        CUSTOM_WARNING_MESSAGES.forEach((warning) => {

            if (_no(isWarning)) {
                isWarning = content.includes(
                    warning
                );

                warningMessage = isWarning
                    ? warning
                    : "";

                if (warningMessage === "User rejected the request") {
                    warningMessage = "Transaction cancelled by user in wallet";
                }
            }
        });


        if (isWarning) {

            warning(
                warningMessage
            );
            return;
        }

        warning(
            DEFAULT_ERROR
        );
    };

    const success = (message) => {
        addToast(
            message,
            {
                appearance: "success",
                ...defaultSetup
            }
        );
    };

    const error = (message) => {
        addToast(
            message,
            {
                appearance: "error",
                ...defaultSetup
            }
        );
    };

    const warning = (message) => {
        addToast(
            message,
            {
                appearance: "warning",
                ...defaultSetup
            }
        );
    };

    const info = (message) => {
        addToast(
            message,
            {
                appearance: "info",
                ...defaultSetup
            }
        );
    };

    return {
        generateLinkContent,
        showToast,
        showTransactionErrorToast,
        success,
        error,
        warning,
        info
    };
};
